import logo from '../assets/logo.png';

const IOS_URL = 'https://apps.apple.com/us/app/its-all-about-the-options/id6741738762';
const ANDROID_URL = 'https://play.google.com/apps/internaltest/4701567087476213772';
const WEB_APP_URL = 'https://itsallaboutheoptions.com/market-data';
const SIGNUP_URL = 'https://itsallaboutheoptions.com/signup';
const QR_URL = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&margin=8&data=${encodeURIComponent(WEB_APP_URL)}`;
const APP_STORE_BADGE = `${process.env.PUBLIC_URL}/badges/app-store.svg`;
const PLAY_STORE_BADGE = `${process.env.PUBLIC_URL}/badges/play-store.svg`;

const AppStoreBadge = ({ href }) => (
  <a href={href} target="_blank" rel="noreferrer" className="inline-block transition hover:scale-[1.03] active:scale-[0.98]">
    <img
      src={APP_STORE_BADGE}
      alt="Download on the App Store"
      className="h-11 w-auto drop-shadow-sm"
      loading="lazy"
    />
  </a>
);

const PlayStoreBadge = ({ href }) => (
  <a href={href} target="_blank" rel="noreferrer" className="inline-block transition hover:scale-[1.03] active:scale-[0.98]">
    <img
      src={PLAY_STORE_BADGE}
      alt="Get it on Google Play"
      className="h-11 w-auto drop-shadow-sm"
      loading="lazy"
    />
  </a>
);

/** iPhone 17 Pro Max–style frame: titanium edges, Dynamic Island, side buttons, home indicator */
const PhoneMockup = ({ variant = 'flash', className = '' }) => (
  <div className={`relative ${className}`}>
    {/* Left side buttons: Action + Volume */}
    <div className="absolute -left-[3px] top-[78px] z-20 h-[22px] w-[3px] rounded-l-sm bg-gradient-to-b from-[#c8c4bd] to-[#9e9a92] shadow-sm" />
    <div className="absolute -left-[3px] top-[112px] z-20 h-[36px] w-[3px] rounded-l-sm bg-gradient-to-b from-[#c8c4bd] to-[#9e9a92] shadow-sm" />
    <div className="absolute -left-[3px] top-[156px] z-20 h-[36px] w-[3px] rounded-l-sm bg-gradient-to-b from-[#c8c4bd] to-[#9e9a92] shadow-sm" />
    {/* Right side: Power */}
    <div className="absolute -right-[3px] top-[128px] z-20 h-[56px] w-[3px] rounded-r-sm bg-gradient-to-b from-[#c8c4bd] to-[#9e9a92] shadow-sm" />

    {/* Titanium chassis — Pro Max proportions (~9:19.5) */}
    <div
      className="relative mx-auto w-[176px] sm:w-[196px] rounded-[2.35rem] p-[2.5px] shadow-[0_25px_50px_-12px_rgba(0,0,0,0.35)]"
      style={{
        background: 'linear-gradient(145deg, #e8e4dc 0%, #b8b3a8 28%, #d4d0c8 52%, #8f8a82 78%, #cfcac0 100%)',
      }}
    >
      <div className="rounded-[2.2rem] bg-[#1c1c1e] p-[1.5px]">
        <div className="relative overflow-hidden rounded-[2.05rem] bg-[#0d0f14]" style={{ aspectRatio: '9 / 19.5' }}>
          {/* Status bar + Dynamic Island */}
          <div className="relative z-10 flex items-center justify-between px-5 pt-3">
            <span className="text-[9px] font-semibold text-white tabular-nums">9:41</span>
            <div className="absolute left-1/2 top-2.5 flex h-[22px] w-[78px] -translate-x-1/2 items-center justify-center rounded-full bg-black shadow-inner">
              <div className="ml-auto mr-2 h-[8px] w-[8px] rounded-full bg-[#1a1a1c] ring-1 ring-[#2a2a2e]" />
            </div>
            <div className="flex items-center gap-1">
              <div className="flex h-[10px] items-end gap-[1.5px]">
                {[3, 5, 7, 9].map((h) => (
                  <div key={h} className="w-[2px] rounded-sm bg-white" style={{ height: h }} />
                ))}
              </div>
              <div className="ml-0.5 h-[8px] w-[16px] rounded-[2px] border border-white/80 p-[1px]">
                <div className="h-full w-[70%] rounded-[1px] bg-white" />
              </div>
            </div>
          </div>

          {/* App UI */}
          <div className="px-3 pb-6 pt-3">
            <div className="mb-3 flex items-center gap-2">
              <img src={logo} alt="" className="h-5 w-5 rounded" />
              <div>
                <p className="text-[9px] font-semibold leading-tight text-white">IAATO</p>
                <p className="text-[7px] leading-tight text-zinc-400">Good morning, Trader</p>
              </div>
            </div>

            {variant === 'flash' ? (
              <>
                <div className="mb-2 rounded-xl bg-zinc-900 px-2.5 py-1.5 text-[8px] text-zinc-400">Search ticker…</div>
                <p className="mb-1.5 text-[8px] font-semibold uppercase tracking-wider text-zinc-500">Trade Flash</p>
                <div className="space-y-1.5">
                  {[
                    { t: 'NVDA', d: 'CALL $128', p: '+$42K', up: true },
                    { t: 'SPY', d: 'PUT $510', p: '-$18K', up: false },
                    { t: 'AAPL', d: 'CALL $190', p: '+$9.2K', up: true },
                    { t: 'TSLA', d: 'CALL $245', p: '+$31K', up: true },
                    { t: 'META', d: 'PUT $520', p: '-$7.1K', up: false },
                  ].map((row) => (
                    <div key={row.t} className="flex items-center justify-between rounded-xl bg-zinc-900/90 px-2.5 py-2">
                      <div>
                        <p className="text-[9px] font-bold text-white">{row.t}</p>
                        <p className="text-[7px] text-zinc-500">{row.d}</p>
                      </div>
                      <span
                        className={`rounded-full px-1.5 py-0.5 text-[7px] font-semibold ${
                          row.up ? 'bg-emerald-500/20 text-emerald-400' : 'bg-rose-500/20 text-rose-400'
                        }`}
                      >
                        {row.p}
                      </span>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="mb-2 rounded-xl bg-zinc-900 px-2.5 py-1.5 text-[8px] text-zinc-400">Where to trade?</div>
                <p className="mb-1.5 text-[8px] font-semibold uppercase tracking-wider text-zinc-500">Market Data</p>
                <div className="mb-2 grid grid-cols-4 gap-1.5">
                  {['Flash', 'Chat', 'Watch', 'Alerts'].map((label) => (
                    <div key={label} className="rounded-xl bg-zinc-900 py-2 text-center">
                      <div className="mx-auto mb-1 h-4 w-4 rounded-full bg-[#6756FE]/40" />
                      <p className="text-[6px] text-zinc-400">{label}</p>
                    </div>
                  ))}
                </div>
                <div className="rounded-xl bg-zinc-900 p-2.5">
                  <div className="mb-2 flex items-center justify-between">
                    <p className="text-[9px] font-bold text-white">QQQ</p>
                    <span className="rounded-full bg-amber-400/20 px-1.5 py-0.5 text-[7px] font-semibold text-amber-300">Live</span>
                  </div>
                  <div className="flex h-20 items-end gap-0.5">
                    {[40, 55, 35, 70, 50, 85, 60, 95, 75, 88].map((h, i) => (
                      <div
                        key={i}
                        className="flex-1 rounded-t-sm bg-gradient-to-t from-[#6756FE] to-[#9b8cff]"
                        style={{ height: `${h}%` }}
                      />
                    ))}
                  </div>
                </div>
                <div className="mt-2 rounded-xl bg-zinc-900 px-2.5 py-2">
                  <div className="flex items-center justify-between">
                    <p className="text-[8px] font-semibold text-white">SPX Options</p>
                    <span className="text-[7px] text-emerald-400">+1.2%</span>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Home indicator */}
          <div className="absolute bottom-2 left-1/2 h-[4px] w-[88px] -translate-x-1/2 rounded-full bg-white/40" />
        </div>
      </div>
    </div>
  </div>
);

const StepCard = ({ number, title, children }) => (
  <div className="group relative overflow-hidden rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm shadow-slate-200/60 transition hover:border-[#6756FE]/35 hover:shadow-md sm:p-6">
    <div className="mb-3 flex items-start gap-3">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#6756FE] text-sm font-bold text-white shadow-md shadow-[#6756FE]/25">
        {number}
      </span>
      <h3 className="pt-1.5 text-base font-semibold leading-snug text-slate-900 sm:text-lg">{title}</h3>
    </div>
    <div className="space-y-3 pl-0 text-sm leading-relaxed text-slate-600 sm:pl-12">{children}</div>
  </div>
);

const Welcome = () => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#f5f4f8] text-slate-800">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 left-1/2 h-[380px] w-[680px] -translate-x-1/2 rounded-full bg-[#6756FE]/12 blur-[100px]" />
        <div className="absolute bottom-0 right-0 h-[280px] w-[280px] rounded-full bg-indigo-300/20 blur-[90px]" />
        <div
          className="absolute inset-0 opacity-[0.35]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(103,86,254,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(103,86,254,0.06) 1px, transparent 1px)',
            backgroundSize: '48px 48px',
          }}
        />
      </div>

      <div className="relative z-10 mx-auto max-w-5xl px-4 py-10 sm:px-6 sm:py-14">
        <header className="mb-10 text-center sm:mb-14">
          <div className="mb-5 inline-flex items-center gap-3 rounded-full border border-slate-200 bg-white px-4 py-2 shadow-sm">
            <img src={logo} alt="It's All About The Options" className="h-8 w-8 object-contain" />
            <span className="text-sm font-semibold tracking-wide text-indigo-600">It&apos;s All About The Options</span>
          </div>
          <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">Welcome aboard</h1>
          <p className="mx-auto mt-3 max-w-2xl text-slate-500">
            Your payment is complete. Follow the steps below to unlock alerts, community chat, and the full Market Data platform.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-amber-300/60 bg-amber-50 px-4 py-2 text-xs font-semibold text-amber-800 sm:text-sm">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-500 opacity-50" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-amber-500" />
            </span>
            Do not close this page until all steps are completed
          </div>
        </header>

        <div className="mb-6 rounded-2xl border border-slate-200 bg-white p-4 text-sm text-slate-500 shadow-sm sm:p-5">
          A receipt for your purchase has been emailed to you. You can also review the transaction in your PayPal account.
        </div>

        <h2 className="mb-5 text-center text-xs font-bold uppercase tracking-[0.25em] text-[#6756FE]">
          Getting you started
        </h2>

        <div className="space-y-4 sm:space-y-5">
          <StepCard number="1" title="Review Terms & Conditions">
            <p>
              Please review our terms on{' '}
              <a href="/terms" className="font-medium text-[#6756FE] underline decoration-[#6756FE]/30 underline-offset-2 hover:text-indigo-800">
                itsallaboutheoptions.com/terms
              </a>
              .
            </p>
          </StepCard>

          <StepCard number="2" title="Enable text alerts">
            <p>From a US-based number, text the keyword below to start receiving alerts:</p>
            <div className="rounded-2xl border border-[#6756FE]/25 bg-[#6756FE]/5 px-4 py-4 text-center">
              <p className="text-xs uppercase tracking-widest text-[#6756FE]">Text keyword</p>
              <p className="mt-1 text-2xl font-bold text-slate-900 sm:text-3xl">
                START <span className="text-lg font-normal text-slate-400">to</span> (855) 958-5307
              </p>
            </div>
            <p>
              <strong className="text-slate-900">Important:</strong> Reply to our welcome text with your full name and email so we can confirm your carrier can send/receive alerts.
            </p>
            <p>
              <strong className="text-slate-900">Non-US customers:</strong> Set up a US number with{' '}
              <a href="https://www.textnow.com" target="_blank" rel="noreferrer" className="text-[#6756FE] underline underline-offset-2 hover:text-indigo-800">
                TextNow
              </a>{' '}
              (web, iOS, or Android).
            </p>
          </StepCard>

          <StepCard number="3" title="Join the community">
            <p>Discuss trading strategies with us online:</p>
            <div className="grid gap-2 sm:grid-cols-3">
              {[
                { label: 'Facebook Group', href: 'https://www.facebook.com/groups/652909564891054' },
                { label: 'FB Alert Channel', href: 'https://m.me/j/Abbd8SjMxi0m_XpU/' },
                { label: 'FB Discussion Channel', href: 'https://www.facebook.com/messages/t/1828084043918783' },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 text-center text-sm font-medium text-slate-800 transition hover:border-[#6756FE]/40 hover:bg-[#6756FE]/8 hover:text-[#6756FE]"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </StepCard>

          {/* App access promo */}
          <section className="relative overflow-hidden rounded-3xl border border-slate-200 bg-gradient-to-br from-white via-[#f8f7fc] to-[#ece8ff] shadow-sm">
            <div
              className="pointer-events-none absolute inset-0 opacity-50"
              style={{
                backgroundImage:
                  'radial-gradient(circle at 85% 25%, rgba(103,86,254,0.18), transparent 42%), linear-gradient(135deg, transparent 45%, rgba(103,86,254,0.08) 55%, transparent 65%)',
              }}
            />
            <div
              className="pointer-events-none absolute inset-0 opacity-[0.4]"
              style={{
                backgroundImage:
                  'linear-gradient(rgba(103,86,254,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(103,86,254,0.08) 1px, transparent 1px)',
                backgroundSize: '28px 28px',
                maskImage: 'linear-gradient(to right, black 0%, transparent 72%)',
              }}
            />

            <div className="relative grid items-center gap-8 p-6 sm:p-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-6 lg:p-10">
              <div>
                <div className="mb-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#6756FE] text-sm font-bold text-white shadow-md shadow-[#6756FE]/30">
                    4
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#6756FE]">Platform access</p>
                </div>

                <h3 className="text-3xl font-bold leading-tight text-slate-900 sm:text-4xl">
                  Take the markets<br className="hidden sm:block" /> with you.
                </h3>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-500 sm:text-base">
                  Access Market Data, Trade Flash, and Chat on desktop, iOS, or Android.
                </p>

                <p className="mt-4 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5 text-xs leading-relaxed text-amber-900/90 sm:text-sm">
                  <strong className="text-amber-900">Note:</strong> Create a login first at{' '}
                  <a href={SIGNUP_URL} className="font-medium text-[#6756FE] underline underline-offset-2">
                    itsallaboutheoptions.com/signup
                  </a>
                  . Use the same email as your PayPal / Stripe / Apple registration.
                </p>

                <div className="mt-6 flex flex-wrap items-end gap-5">
                  <div className="rounded-2xl border border-slate-200 bg-white p-3 shadow-lg shadow-slate-300/40">
                    <img src={QR_URL} alt="QR code to open Market Data web app" className="h-[120px] w-[120px] sm:h-[140px] sm:w-[140px]" />
                    <p className="mt-1 text-center text-[10px] font-medium text-slate-500">Scan for Web App</p>
                  </div>
                  <div className="flex flex-col gap-2.5">
                    <AppStoreBadge href={IOS_URL} />
                    <PlayStoreBadge href={ANDROID_URL} />
                    <a
                      href={WEB_APP_URL}
                      className="inline-flex h-11 items-center justify-center rounded-lg border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-800 shadow-sm transition hover:border-[#6756FE]/40 hover:text-[#6756FE]"
                    >
                      Open Web App →
                    </a>
                  </div>
                </div>
              </div>

              <div className="relative mx-auto flex h-[380px] w-full max-w-md items-end justify-center sm:h-[420px]">
                <PhoneMockup
                  variant="data"
                  className="absolute left-2 top-8 z-0 -rotate-[8deg] scale-[0.88] opacity-95 sm:left-6 sm:top-4 sm:scale-95"
                />
                <PhoneMockup
                  variant="flash"
                  className="absolute right-0 top-0 z-10 rotate-[8deg] sm:right-4"
                />
              </div>
            </div>
          </section>

          <StepCard number="5" title="New to options trading?">
            <p>
              Refer to our{' '}
              <a
                href="/guide_pdf.pdf"
                target="_blank"
                rel="noreferrer"
                className="font-medium text-[#6756FE] underline decoration-[#6756FE]/30 underline-offset-2 hover:text-indigo-800"
              >
                Options Trading Best Practices Guide
              </a>
              .
            </p>
          </StepCard>
        </div>

        <footer className="mt-12 border-t border-slate-200 pt-8 text-center text-sm text-slate-500">
          <div className="mb-3 flex items-center justify-center gap-3">
            <a href="https://facebook.com/groups/652909564891054" target="_blank" rel="noreferrer" className="transition hover:text-[#6756FE]">
              Facebook
            </a>
            <span className="text-slate-300">|</span>
            <a href="https://twitter.com/aboutheoptions" target="_blank" rel="noreferrer" className="transition hover:text-[#6756FE]">
              Twitter
            </a>
          </div>
          <p>&copy; {new Date().getFullYear()} It&apos;s All About The Options</p>
          <p className="mt-2">
            <a href="/terms" className="transition hover:text-[#6756FE]">Terms &amp; Conditions</a>
            <span className="mx-2 text-slate-300">|</span>
            <a href="/privacy-policy" className="transition hover:text-[#6756FE]">Privacy Policy</a>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Welcome;
